import { Stack } from '@mui/material';
import React from 'react';
import PacsCard from './PacsCard';

const PacsList = ({ pacsConfer }) => {


 

  

  return (
    <React.Fragment>
      <Stack gap=".5em">
        {pacsConfer?.map((pacs, index) => (
          <PacsCard pacs={pacs} key={pacs.IdBillDetails} />
        ))}
      </Stack>
    </React.Fragment>
  );
};

export default PacsList;
